export default __webpack_public_path__ + "static/1074-e7b2c08fa4550b8847c56bb845c8ab3d.gif";